import { useTranslation } from "react-i18next";
import LegalLayout from "@/components/LegalLayout";

const sections = [
  {
    id: "intro",
    title: "Who this notice is from",
    body: [
      "Instantxfer CashApp Financial Technologies B.V., Brouwerijstraat 1B, Kampenhout (BE), is the controller of the personal data described in this notice. If you have questions, reach us at legal@instantxfer.com.",
    ],
  },
  {
    id: "collect",
    title: "What we collect",
    body: [
      "Identity data — full name, date of birth, address, nationality, photo of your government ID, and a short liveness selfie captured only during KYC.",
      "Transaction data — send amount, currency, recipient details, delivery method, timestamps, device IDs, and IP.",
      "Contact data — email, phone number, and preferences.",
      "Product usage — pages viewed, features used, crash reports, and diagnostic telemetry.",
    ],
  },
  {
    id: "use",
    title: "How we use it",
    body: [
      "To provide the Service — process transfers, prevent fraud, run KYC/AML checks, and respond to support requests.",
      "To comply with legal obligations — record-keeping, sanctions screening, and regulatory reporting.",
      "To improve Instantxfer CashApp — aggregated analytics, product research, and personalising your onboarding.",
      "For marketing communications you've opted into. You can withdraw consent any time.",
    ],
  },
  {
    id: "basis",
    title: "Legal basis (GDPR)",
    body: [
      "Contract — to provide the Service you've asked for. Legal obligation — for AML/CTF and sanctions duties. Legitimate interests — to prevent fraud and improve Instantxfer CashApp. Consent — for optional marketing and analytics cookies.",
    ],
  },
  {
    id: "share",
    title: "Who we share with",
    body: [
      "Regulated payout partners in each corridor, KYC/AML providers, cloud infrastructure providers, fraud-prevention vendors, and law enforcement or regulators when legally required.",
      "We never sell your personal data.",
    ],
  },
  {
    id: "retention",
    title: "How long we keep it",
    body: [
      "Identity and transaction records — up to 7 years after account closure, as required by AML law.",
      "Product usage telemetry — up to 26 months.",
      "Marketing preferences — until you opt out.",
    ],
  },
  {
    id: "rights",
    title: "Your rights",
    body: [
      "You have the right to access, correct, delete or export your data, restrict or object to processing, and to lodge a complaint with a supervisory authority. To exercise these rights, contact legal@instantxfer.com — we respond within 30 days.",
    ],
  },
  {
    id: "transfers",
    title: "International transfers",
    body: [
      "Some of our processors are outside the EEA. Where that is the case, we use the European Commission's Standard Contractual Clauses and, where applicable, supplementary measures such as encryption at rest and in transit.",
    ],
  },
  {
    id: "security",
    title: "Security",
    body: [
      "We protect your data with encryption at rest (AES-256) and in transit (TLS 1.3), device-bound session tokens, zero-knowledge sync for contacts and history, and continuous monitoring by our security team.",
    ],
  },
  {
    id: "changes",
    title: "Changes",
    body: [
      "We'll notify you in-app or by email at least 30 days before any material change to this notice takes effect.",
    ],
  },
];

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <LegalLayout
      eyebrow={t("pageHero.privacy.eyebrow")}
      title={t("pageHero.privacy.title")}
      updated="December 2025"
      sections={sections}
      testId="privacy-page"
    />
  );
}
